(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecom-tab-abandon-flicker"] && !Shopify.designMode) return;
  try {
    (function () {
  var originalTitle = document.title;
  var messages = ['Come Back 👀', '🔥 Don\'t forget this...'];
  var interval = null;
  var msgIndex = 0;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      interval = setInterval(function () {
        document.title = messages[msgIndex % messages.length];
        msgIndex++;
      }, 1200);
    } else {
      clearInterval(interval);
      interval = null;
      msgIndex = 0;
      document.title = originalTitle;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
